import { getFormatDate } from "~/libs/getFormatDate";
import { TFunction } from "i18next";
import { IndicatorGroup } from "~/schemas/generated/graphql";
import { IndicatorGroupStatus } from "~/types/IndicatorGroupStatus";

export const tableDataFormatter = (data: IndicatorGroup[], t: TFunction) => {
  if (!data || !Array.isArray(data)) {
    return [];
  }
  return data.map((el) => ({
    ...el,
    status: t(`reports_list.${el.status}`) as IndicatorGroupStatus,
    createdBy: el.createdByUser?.fullname,
    writtenBy: el.writtenByUser?.fullname,
    createdAt: getFormatDate(el.createdAt, true),
    updatedAt: getFormatDate(el.updatedAt, true),
  }));
};
